import { createSelector, MemoizedSelector } from '@ngrx/store';
import { PromoEntity } from '@promo/const';
import { StateUtils } from '@spartacus/core';
import { PromoState, StateWithPromo } from '../promo-state';
import { getFeatureState } from './feature.selector';

export const getPromoState: MemoizedSelector<StateWithPromo, StateUtils.LoaderState<PromoEntity>> = createSelector(
  getFeatureState,
  (state: PromoState) => state.promo,
);

export const getPromoValue: MemoizedSelector<StateWithPromo, PromoEntity> = createSelector(
  getPromoState,
  (state: StateUtils.LoaderState<PromoEntity>) => StateUtils.loaderValueSelector(state),
);

export const getPromoLoading: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getPromoState,
  (state: StateUtils.LoaderState<PromoEntity>) => StateUtils.loaderLoadingSelector(state),
);

export const getPromoError: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getPromoState,
  (state: StateUtils.LoaderState<PromoEntity>) => StateUtils.loaderErrorSelector(state),
);

export const getPromoSuccess: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getPromoState,
  (state: StateUtils.LoaderState<PromoEntity>) => StateUtils.loaderSuccessSelector(state),
);
